<!-- Cabecalho da pagina (padrao .page-header do sistema: irmao do .page-body) -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-bell"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'notificacoes.titulo_pagina' | translate }}</h1>
    <p class="header-subtitle">{{ 'notificacoes.subtitulo' | translate }}</p>
  </div>
  <button *ngIf="mostrarVoltar"
          pButton type="button"
          class="p-button-secondary btn-voltar"
          icon="pi pi-arrow-left"
          [label]="'notificacoes.voltar' | translate"
          (click)="voltar()">
  </button>
</div>

<div class="page-body">

  <!-- ===================================================================== -->
  <!-- SECAO 0: Meu contrato (contrato ATIVO do cliente com o contador)        -->
  <!-- Permanece FORA das abas (contexto do contrato, acima do conteudo).      -->
  <!-- ===================================================================== -->
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-briefcase"></i>
      </div>
      <span class="card-header-title">{{ 'notificacoes.secao_contrato_ativo' | translate }}</span>
    </div>

    <div class="card-content">
      <!-- Loading -->
      <div *ngIf="carregandoContratoVigente" class="estado-loading">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
        <span>{{ 'notificacoes.carregando' | translate }}</span>
      </div>

      <!-- Erro -->
      <div *ngIf="!carregandoContratoVigente && erroContratoVigente" class="estado-erro">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'notificacoes.erro' | translate }}</span>
        <button pButton type="button"
                class="p-button-sm p-button-outlined"
                icon="pi pi-refresh"
                [label]="'notificacoes.tentar_novamente' | translate"
                (click)="carregarContratoVigente()">
        </button>
      </div>

      <!-- Sem contrato ativo -->
      <div *ngIf="!carregandoContratoVigente && !erroContratoVigente && !contratoVigente"
           class="estado-vazio-secao">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'notificacoes.contrato_ativo.sem_contrato' | translate }}</span>
      </div>

      <!-- Contrato ativo (cliente): explicacao + detalhe do contrato (card
           compartilhado, somente leitura) + switch de autonomia. Empilha em
           coluna (ver .meu-contrato no SCSS). -->
      <div *ngIf="!carregandoContratoVigente && !erroContratoVigente && contratoVigente"
           class="contrato-card contrato-card--ativo meu-contrato">
        <p class="contrato-card__explicacao">
          {{ 'notificacoes.contrato_ativo.explicacao' | translate }}
        </p>

        <!-- Detalhe do contrato: mesmo card compartilhado do "Contrato ativo" do
             contador, aqui em modo somente leitura (mes de referencia vira texto)
             e sem o campo autonomia, exibido no switch abaixo. -->
        <app-contrato-info-card
          [contrato]="contratoInfoVM"
          [moedaConfig]="moedaConfig"
          [plano]="true"
          [mostrarAutonomia]="false"
          [nomeLabelKey]="'notificacoes.contrato.contador'"
          [mesReferenciaEditavel]="false"
          [mesReferenciaOptions]="mesReferenciaOptions"
          [mesReferenciaValor]="contratoMesReferencia">
        </app-contrato-info-card>

        <!-- Bloco de AUTONOMIA: conceder/revogar a autonomia do contador. Conceder
             e ato de confianca (dialogo de confirmacao antes de LIGAR); revogar e
             direto. O estado exibido vem do contrato vigente e so muda pelo retorno. -->
        <div class="contrato-card__autonomia">
          <div class="autonomia__texto">
            <span class="autonomia__titulo">
              <i class="pi pi-shield" aria-hidden="true"></i>
              {{ 'notificacoes.autonomia.titulo' | translate }}
            </span>
            <span class="autonomia__descricao">{{ 'notificacoes.autonomia.descricao' | translate }}</span>
          </div>
          <div class="autonomia__controle">
            <span class="autonomia__estado">
              {{ (autonomiaAtiva ? 'notificacoes.autonomia.ligada' : 'notificacoes.autonomia.desligada') | translate }}
            </span>
            <p-inputSwitch #autonomiaSwitch
                           [(ngModel)]="autonomiaAtiva"
                           [disabled]="definindoAutonomia"
                           (onChange)="onAutonomiaToggle($event)"
                           [ariaLabel]="'notificacoes.autonomia.titulo' | translate">
            </p-inputSwitch>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================================== -->
  <!-- SECAO 1: Solicitacoes de contrato do contador                          -->
  <!-- Permanece FORA das abas (pendencia de contrato, nao de despesa) e so    -->
  <!-- aparece quando ha solicitacoes pendentes.                               -->
  <!-- ===================================================================== -->
  <div class="table-card" *ngIf="carregandoContratos || erroContratos || contratos.length > 0">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-file-edit"></i>
      </div>
      <span class="card-header-title">{{ 'notificacoes.secao_contratos' | translate }}</span>
      <!-- Icone informativo: explica o efeito de aceitar/recusar a solicitacao. -->
      <i class="pi pi-info-circle info-acoes"
         tabindex="0"
         role="img"
         [attr.aria-label]="'notificacoes.contrato.acoes_info' | translate"
         [pTooltip]="'notificacoes.contrato.acoes_info' | translate"
         tooltipPosition="top"></i>
    </div>

    <div class="card-content">
      <!-- Loading -->
      <div *ngIf="carregandoContratos" class="estado-loading">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
        <span>{{ 'notificacoes.carregando' | translate }}</span>
      </div>

      <!-- Erro -->
      <div *ngIf="!carregandoContratos && erroContratos" class="estado-erro">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'notificacoes.erro' | translate }}</span>
        <button pButton type="button"
                class="p-button-sm p-button-outlined"
                icon="pi pi-refresh"
                [label]="'notificacoes.tentar_novamente' | translate"
                (click)="carregarContratos()">
        </button>
      </div>

      <!-- Lista de solicitacoes -->
      <div *ngIf="!carregandoContratos && !erroContratos" class="contratos-lista">
        <div class="contrato-card" *ngFor="let contrato of contratos">
          <div class="contrato-card__topo">
            <i class="pi pi-briefcase"></i>
            <span class="contrato-card__contador">{{ contrato.nomeContador }}</span>
          </div>

          <p class="contrato-card__explicacao">
            {{ 'notificacoes.contrato.explicacao' | translate: { contador: contrato.nomeContador } }}
          </p>

          <div class="contrato-card__dados">
            <div class="dado">
              <span class="dado__label">{{ 'notificacoes.contrato.desconto' | translate }}</span>
              <span class="dado__valor">{{ contrato.percentualDesconto }}%</span>
            </div>
            <div class="dado">
              <span class="dado__label">{{ 'notificacoes.contrato.valor' | translate }}</span>
              <span class="dado__valor">
                {{ formatarValorMoeda(contrato.valorMensal, contrato.moeda?.enum) }}
              </span>
            </div>
            <div class="dado" *ngIf="contrato.diaCobranca != null">
              <span class="dado__label">{{ 'notificacoes.contrato.cobranca' | translate }}</span>
              <span class="dado__valor">
                {{ 'notificacoes.contrato.dia_valor' | translate: { dia: contrato.diaCobranca } }}
              </span>
            </div>
            <div class="dado" *ngIf="contrato.dataVencimento">
              <span class="dado__label">{{ 'notificacoes.contrato.vencimento' | translate }}</span>
              <span class="dado__valor">{{ contrato.dataVencimento | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>

          <div class="contrato-card__acoes">
            <button pButton type="button"
                    severity="danger"
                    icon="pi pi-times"
                    [label]="'notificacoes.contrato.recusar' | translate"
                    [pTooltip]="'notificacoes.contrato.recusar_tooltip' | translate"
                    tooltipPosition="top"
                    [disabled]="processando"
                    (click)="recusarContrato(contrato)">
            </button>
            <button pButton type="button"
                    icon="pi pi-check"
                    [label]="'notificacoes.contrato.aceitar' | translate"
                    [pTooltip]="'notificacoes.contrato.aceitar_tooltip' | translate"
                    tooltipPosition="top"
                    [disabled]="processando"
                    (click)="aceitarContrato(contrato)">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================================== -->
  <!-- Abas: Despesas do contador (pendentes) | Historico de gastos |          -->
  <!-- Parcelas do contrato (so quando ha contrato ATIVO com id).              -->
  <!-- Aba 1 (Despesas) ativa por default. Os cards internos mantem o header   -->
  <!-- com icone + titulo (FORM_UI.md), com titulo DIFERENTE do rotulo da aba  -->
  <!-- (mesma tecnica de /indicacoes e /contador/operar). Estilo das abas:     -->
  <!-- classe global .tabs-underline (src/styles/_tabs-underline.scss).        -->
  <!-- (onChange): dispara a 1a carga das parcelas ao abrir a 3a aba           -->
  <!-- (ver onTabViewChange no component).                                     -->
  <!-- *ngIf="mostrarAbas": o bloco INTEIRO some quando nao ha absolutamente   -->
  <!-- nada para ver (sem contrato ativo + zero pendentes + zero historico) —  -->
  <!-- evita a tabela vazia de 7 colunas para quem nunca teve contador. NAO e  -->
  <!-- "sem contrato ativo": despesas e historico sobrevivem ao cancelamento   -->
  <!-- do contrato. Ver avaliarVisibilidadeAbas() no component.                -->
  <!-- ===================================================================== -->
  <p-tabView *ngIf="mostrarAbas" styleClass="tabs-underline" (onChange)="onTabViewChange($event)">

    <!-- ------------------------------------------------------------------- -->
    <!-- ABA 1: Despesas acessorias pendentes de aprovacao                    -->
    <!-- ------------------------------------------------------------------- -->
    <p-tabPanel [header]="'notificacoes.secao_despesas' | translate">
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <span class="card-header-title">{{ 'notificacoes.despesa.titulo_pendentes' | translate }}</span>
        </div>

        <div class="card-content">
          <!-- Loading -->
          <div *ngIf="carregandoDespesas" class="estado-loading">
            <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
            <span>{{ 'notificacoes.carregando' | translate }}</span>
          </div>

          <!-- Erro -->
          <div *ngIf="!carregandoDespesas && erroDespesas" class="estado-erro">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ 'notificacoes.erro' | translate }}</span>
            <button pButton type="button"
                    class="p-button-sm p-button-outlined"
                    icon="pi pi-refresh"
                    [label]="'notificacoes.tentar_novamente' | translate"
                    (click)="carregarDespesas()">
            </button>
          </div>

          <!-- Lista de despesas -->
          <ng-container *ngIf="!carregandoDespesas && !erroDespesas">
            <p class="secao-explicacao" *ngIf="despesas.length > 0">
              {{ 'notificacoes.despesa.explicacao_lista' | translate }}
            </p>

            <!-- Paginacao CLIENT-SIDE: a API de pendentes (listarPendentes) devolve a
                 lista completa (nao paginada), entao o p-table pagina em memoria.
                 Aparece so quando ha mais itens que o tamanho da pagina. -->
            <p-table [value]="despesas"
                     [rowHover]="true"
                     [tableStyle]="tabelaPendentesStyle"
                     styleClass="tabela-espacada"
                     [paginator]="despesas.length > 10"
                     [rows]="10"
                     [rowsPerPageOptions]="[10, 20, 50]"
                     responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 14%">{{ 'notificacoes.despesa.contador' | translate }}</th>
                  <th style="width: 18%">{{ 'notificacoes.despesa.tipo' | translate }}</th>
                  <th class="text-right" style="width: 11%">{{ 'notificacoes.despesa.valor' | translate }}</th>
                  <th style="width: 13%">{{ 'notificacoes.despesa.data_pagamento' | translate }}</th>
                  <th class="text-center" style="width: 10%">{{ 'notificacoes.despesa.especial' | translate }}</th>
                  <th class="text-center" style="width: 21%">
                    <span class="col-acoes-header">
                      {{ 'notificacoes.col_acoes' | translate }}
                      <!-- Icone informativo: resume o efeito de aprovar/recusar o gasto. -->
                      <i class="pi pi-info-circle info-acoes"
                         tabindex="0"
                         role="img"
                         [attr.aria-label]="'notificacoes.col_acoes_info' | translate"
                         [pTooltip]="'notificacoes.col_acoes_info' | translate"
                         tooltipPosition="top"></i>
                    </span>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-despesa>
                <tr [class.linha-iva]="ehIva(despesa.tipoDespesa)">
                  <ng-container *ngTemplateOutlet="colunasDespesaComum; context: { $implicit: despesa }"></ng-container>
                  <td class="text-center actions">
                    <button pButton type="button"
                            severity="danger"
                            class="btn-sm"
                            icon="pi pi-times"
                            [label]="'notificacoes.despesa.recusar' | translate"
                            [pTooltip]="'notificacoes.despesa.recusar_tooltip' | translate"
                            tooltipPosition="top"
                            [disabled]="processando"
                            (click)="recusarDespesa(despesa)">
                    </button>
                    <button pButton type="button"
                            class="btn-sm ml-2"
                            icon="pi pi-check"
                            [label]="'notificacoes.despesa.aprovar' | translate"
                            [pTooltip]="'notificacoes.despesa.aprovar_tooltip' | translate"
                            tooltipPosition="top"
                            [disabled]="processando"
                            (click)="aprovarDespesa(despesa)">
                    </button>
                  </td>
                </tr>
              </ng-template>

              <!-- Estado vazio: nenhuma despesa pendente (a aba nunca fica em branco). -->
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7" class="text-center historico-vazio">
                    <i class="pi pi-inbox"></i>
                    <span>{{ 'notificacoes.despesa.pendentes_vazio' | translate }}</span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- ------------------------------------------------------------------- -->
    <!-- ABA 2: Historico de gastos decididos (aprovados/recusados)           -->
    <!-- Conteudo em ng-template pTemplate="content": o PrimeNG so renderiza   -->
    <!-- na PRIMEIRA ativacao da aba (cache default = true, depois permanece   -->
    <!-- montado). Assim o GET do historico so dispara quando o usuario abre a -->
    <!-- aba — conteudo projetado direto (sem pTemplate) renderizaria eager.   -->
    <!-- ------------------------------------------------------------------- -->
    <p-tabPanel [header]="'notificacoes.secao_historico' | translate">
      <ng-template pTemplate="content">
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-history"></i>
          </div>
          <span class="card-header-title">{{ 'notificacoes.despesa.titulo_historico' | translate }}</span>
        </div>

        <div class="card-content">
          <!-- Erro (faixa acima da tabela; nao desmonta a tabela lazy) -->
          <div *ngIf="erroHistorico" class="estado-erro">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ 'notificacoes.erro' | translate }}</span>
            <button pButton type="button"
                    class="p-button-sm p-button-outlined"
                    icon="pi pi-refresh"
                    [label]="'notificacoes.tentar_novamente' | translate"
                    (click)="carregarHistorico()">
            </button>
          </div>

          <!-- Tabela (somente leitura; paginacao/ordenacao SERVER-SIDE via lazy +
               paginador separado, padrao da Area do Contador). -->
          <p-table [value]="historico"
                   [lazy]="true"
                   (onLazyLoad)="onHistoricoLazyLoad($event)"
                   [rows]="historicoRows"
                   [first]="historicoFirst"
                   [totalRecords]="historicoTotalRecords"
                   [loading]="carregandoHistorico"
                   [rowHover]="true"
                   [tableStyle]="tabelaHistoricoStyle"
                   styleClass="tabela-espacada"
                   responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'notificacoes.despesa.contador' | translate }}</th>
                <th pSortableColumn="tipoDespesa">
                  {{ 'notificacoes.despesa.tipo' | translate }}<p-sortIcon [field]="'tipoDespesa'"></p-sortIcon>
                </th>
                <th class="text-right" pSortableColumn="valor">
                  {{ 'notificacoes.despesa.valor' | translate }}<p-sortIcon [field]="'valor'"></p-sortIcon>
                </th>
                <th pSortableColumn="dataPagamento">
                  {{ 'notificacoes.despesa.data_pagamento' | translate }}<p-sortIcon [field]="'dataPagamento'"></p-sortIcon>
                </th>
                <th class="text-center">{{ 'notificacoes.despesa.especial' | translate }}</th>
                <th class="text-center" pSortableColumn="status">
                  {{ 'notificacoes.despesa.situacao' | translate }}<p-sortIcon [field]="'status'"></p-sortIcon>
                </th>
                <th class="text-center">{{ 'notificacoes.despesa.pagamento' | translate }}</th>
                <th pSortableColumn="dataDecisao">
                  {{ 'notificacoes.despesa.data_decisao' | translate }}<p-sortIcon [field]="'dataDecisao'"></p-sortIcon>
                </th>
                <th class="text-center">{{ 'notificacoes.col_acoes' | translate }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr [class.linha-iva]="ehIva(item.tipoDespesa)">
                <ng-container *ngTemplateOutlet="colunasDespesaComum; context: { $implicit: item }"></ng-container>
                <td class="text-center">
                  <p-tag [value]="historicoStatusLabel(item.status)"
                         [severity]="historicoStatusSeverity(item.status)">
                  </p-tag>
                </td>
                <td class="text-center">
                  <p-tag *ngIf="mostrarTagPagamento(item); else semPagamento"
                         [value]="pagamentoLabel(item)"
                         [severity]="pagamentoSeverity(item)"
                         [pTooltip]="pagamentoTooltip(item)"
                         tooltipPosition="top">
                  </p-tag>
                  <ng-template #semPagamento><span aria-hidden="true">–</span></ng-template>
                </td>
                <td>{{ formatarDataDecisao(item.dataDecisao) }}</td>
                <td class="text-center">
                  <button *ngIf="podeVerContaPagar(item)"
                          pButton type="button"
                          class="p-button-sm p-button-text btn-conta-pagar"
                          icon="pi pi-wallet"
                          [pTooltip]="'notificacoes.despesa.ver_conta_pagar' | translate"
                          tooltipPosition="top"
                          [attr.aria-label]="'notificacoes.despesa.ver_conta_pagar' | translate"
                          (click)="verContaPagar(item)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <!-- Nao exibe "nenhum gasto" quando ha erro: a faixa de erro acima ja
                   explica o estado (evita mensagem contraditoria). -->
              <tr *ngIf="!erroHistorico">
                <td colspan="10" class="text-center historico-vazio">
                  <i class="pi pi-inbox"></i>
                  <span>{{ 'notificacoes.historico_vazio' | translate }}</span>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="10" class="text-center estado-loading">
                  <i class="pi pi-spinner pi-spin"></i>
                  <span>{{ 'notificacoes.carregando' | translate }}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao server-side (layout separado; controla a pagina via lazy) -->
          <div class="pagination-container"
               *ngIf="!erroHistorico && historicoTotalRecords > 0">
            <div>
              <p-paginator (onPageChange)="onHistoricoPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="historicoFirst" [rows]="historicoRows"
                [totalRecords]="historicoTotalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ 'notificacoes.itens_por_pagina' | translate }}</span>
              <p-dropdown [options]="historicoPageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="historicoRows"
                (ngModelChange)="onHistoricoRowsPerPageChange()" appendTo="body" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
      </ng-template>
    </p-tabPanel>

    <!-- ------------------------------------------------------------------- -->
    <!-- ABA 3: Parcelas do contrato do cliente (mensalidade do servico do    -->
    <!-- contador), somente leitura. A aba INTEIRA so existe quando ha         -->
    <!-- contrato ATIVO com contratoId — o *ngIf no p-tabPanel substitui o     -->
    <!-- antigo gate por ng-container: contratos legados (sem id) nem veem a   -->
    <!-- aba. Por ser a ULTIMA aba e as duas anteriores serem incondicionais,  -->
    <!-- ocupa sempre o indice 2 quando renderizada (ver onTabViewChange).     -->
    <!-- Conteudo em pTemplate="content" (lazy DOM, mesmo padrao da aba 2): o  -->
    <!-- grid so monta na 1a ativacao; a carga dos dados e disparada pelo      -->
    <!-- (onChange) do p-tabView. O shared app-parcelas-contrato ja e um       -->
    <!-- .table-card com header proprio (nao aninhar outro card).              -->
    <!-- ------------------------------------------------------------------- -->
    <p-tabPanel *ngIf="contratoVigente?.contratoId != null"
                [header]="'notificacoes.parcelas.aba' | translate">
      <ng-template pTemplate="content">
        <app-parcelas-contrato
          [tituloTooltip]="'notificacoes.parcelas.explicacao' | translate"
          [tituloTooltipAria]="'notificacoes.parcelas.explicacao_aria' | translate"
          [parcelas]="parcelasCliente"
          [carregando]="carregandoParcelasCliente"
          [erro]="erroParcelasCliente"
          [totalParcelasContrato]="null"
          [sortField]="parcelasClienteSortField"
          [sortOrder]="parcelasClienteSortOrder"
          (sortChange)="onParcelasClienteSort($event)"
          [first]="parcelasClienteFirst"
          [rows]="parcelasClienteRows"
          [totalRecords]="parcelasClienteTotalRecords"
          (pageChange)="onParcelasClientePageChange($event)"
          (rowsChange)="parcelasClienteRows = $event; onParcelasClienteRowsPerPageChange()"
          (periodoChange)="onParcelasClientePeriodoChanged($event)"
          [situacao]="parcelasClienteSituacao"
          [situacaoOptions]="parcelasClienteSituacaoOptions"
          (situacaoChange)="onParcelasClienteSituacaoChange($event)"
          (recarregar)="recarregarParcelasCliente()"
          [mostrarAcoesContador]="false"
          [mostrarColunasContador]="false"
          [mostrarSaldo]="true">
        </app-parcelas-contrato>
      </ng-template>
    </p-tabPanel>

  </p-tabView>

</div>

<!-- Colunas comuns as duas tabelas (pendentes e historico): contador, tipo (+tag
     IVA), valor, data de pagamento e "despesa especial" (icone + alternativa
     textual sr-only para leitores de tela). Mantidas em um unico template para
     as duas abas nao divergirem em formatacao/acessibilidade. -->
<ng-template #colunasDespesaComum let-registro>
  <td>{{ registro.nomeContador }}</td>
  <td>
    <span class="tipo-nome">{{ tipoDespesaNome(registro.tipoDespesa) }}</span>
    <p-tag *ngIf="ehIva(registro.tipoDespesa)"
           styleClass="tag-iva"
           severity="warning"
           [value]="'notificacoes.despesa.iva' | translate">
    </p-tag>
  </td>
  <td class="text-right">{{ registro.valor | guaraniFormat }}</td>
  <td>{{ registro.dataPagamento | date: 'dd/MM/yyyy' }}</td>
  <td class="text-center">
    <i class="pi"
       aria-hidden="true"
       [class.pi-check-circle]="registro.especial"
       [class.pi-minus]="!registro.especial"
       [class.especial-sim]="registro.especial"></i>
    <span class="sr-only">
      {{ (registro.especial ? 'notificacoes.despesa.sim' : 'notificacoes.despesa.nao') | translate }}
    </span>
  </td>
</ng-template>

<!-- ===================================================================== -->
<!-- Dialogo de confirmacao (padrao wave do sistema — FORM_UI.md).           -->
<!-- Um unico dialogo generico atende as quatro acoes da tela (aceitar/      -->
<!-- recusar contrato, aprovar/recusar despesa). Titulo, cor do header,      -->
<!-- icone, mensagem e botao de confirmar sao definidos pelos campos confirm* -->
<!-- do component ao abrir (ver aceitar/recusarContrato, aprovar/recusarDespesa). -->
<!-- ===================================================================== -->
<p-dialog
  [(visible)]="confirmVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharConfirmacao()">

  <!-- HEADER WAVE (cor conforme a variante: info=azul, danger=vermelho) -->
  <div class="dialog-wave-header" [ngClass]="'dialog-wave-header--' + confirmVariante">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i [ngClass]="confirmIcone" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ confirmTitulo | translate }}</h2>
        <p *ngIf="confirmSubtitulo">{{ confirmSubtitulo }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO: mensagem da confirmacao -->
  <div class="dialog-wave-body">
    <p>{{ confirmMensagem | translate }}</p>
  </div>

  <!-- FOOTER: cancelar (secundario) + confirmar (azul ou danger) -->
  <ng-template pTemplate="footer">
    <button pButton type="button"
            class="p-button-secondary"
            [label]="'notificacoes.cancelar' | translate"
            [disabled]="processando"
            (click)="fecharConfirmacao()">
    </button>
    <button pButton type="button"
            [ngClass]="{ 'p-button-danger': confirmVariante === 'danger' }"
            [icon]="confirmIcone"
            [label]="confirmBotaoLabel | translate"
            [disabled]="processando"
            (click)="confirmarAcao()">
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
